<script
  lang="ts"
  setup
>
import { useLocalePath } from '#imports'
import {
  nextTick,
  onMounted,
  watch,
} from 'vue'
import { useI18n } from 'vue-i18n'
import { RoutePath } from '~/types/enum'

const localePath = useLocalePath()
const { locale } = useI18n()

// 动态改变--footer-height
const changeFooterHeight = () => {
  const footerHeight = document.querySelector('footer')?.clientHeight
  if (footerHeight) {
    document.documentElement.style.setProperty('--footer-height', `${footerHeight || 87}px`)
  }
}

onMounted(() => changeFooterHeight())

// 每次切换语言都要重新计算高度
watch(locale, () => nextTick(() => changeFooterHeight()))

</script>
<template>
  <footer>
    <div class="agreement">
      <a
        :href="localePath(RoutePath.POLICY_PRIVACY_POLICY)"
        target="_blank"
      >
        {{ $t('basic-privacy-policy') }}
      </a>
      <span class="divider" />
      <a
        :href="localePath('/policy/user-agreement')"
        target="_blank"
      >
        {{ $t('basic-user-agreement') }}
      </a>
      <span class="divider" />
      <a
        :href="localePath('/policy/anti-abuse')"
        target="_blank"
      >
        {{ $t('iAjHkhm94xq4M7q72yGF') }}
      </a>
      <span class="divider" />
      <a
        :href="localePath('/policy/child-sexual-abuse')"
        target="_blank"
      >
        {{ $t('pweJ9RndSd1sIzpoOsOwv') }}
      </a>
      <span class="divider" />
      <a
        :href="localePath('/policy/copyright-Infringement')"
        target="_blank"
      >
        {{ $t('xjcgYiATpZVlotKqGkyFz') }}
      </a>
    </div>
    <span class="copyright">
      PIKCLOUD PTE. LTD.&copy; {{ (new Date()).getFullYear() }}
    </span>
  </footer>
</template>

<style
  lang="less"
  scoped
>
@import 'assets/styles/util.less';

footer {
  /* height: 107px; */
  background: #eef0f2;
  display: flex;
  flex: 0 0 107px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  padding: 32px 0;

  .agreement {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;

    a {
      font-weight: 500;
      line-height: 20px;
      text-decoration: none;
      color: var(--color-primary-text);

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .divider {
    margin: 0 8px;
    height: 14px;
    width: 1px;
    background: var(--color-primary-text);
    display: inline-block;
  }

  .copyright {
    color: #979797;
    margin-top: 8px;
    line-height: 15px;
  }
}

@media screen and (max-width: @mobile-break-width) {
  footer {
    /* height: 87px; */
    flex: 0 0 60px;
    padding: 12px;
  }
}
</style>
